import gql from "graphql-tag";

export const IMPORT_SECTION_ASSET = gql`
  mutation ImportSectionAsset($costumeFeatureId: ID!, $costumeTypeId: ID!) {
    importSectionAsset(
      costumeFeatureId: $costumeFeatureId
      costumeTypeId: $costumeTypeId
    ) {
      id
      name
      isCommon
      section {
        id
        name
      }
      costumeType {
        id
        name
      }
    }
  }
`;
